import baseRoute from '../baseRoute';

export default `${baseRoute}/job` as const;
